import { useSearchParams } from 'react-router-dom'

export const useSearchQuery = (searchParamName = `search`): string => {
  const [params] = useSearchParams()
  return params.get(searchParamName) || ``
}
